import PropTypes from "prop-types";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MultiSelectTree } from "@progress/kendo-react-dropdowns";
import {
  setFilterExtendedStatsDomains,
  fetchExtendedStatsDomains,
} from "../../store/app/DataQualityStatus/DataQualitySlice";
import useMultiSelectTree from "../hooks/useMultiSelectTree";

const ExtendedStatsSelector = ({ defaultValue = [] }) => {
  const dispatch = useDispatch();

  const extendedStatsDomains = useSelector((state) => state.dataQualityReducer.extendedStatsDomains);
  const stateValue = useSelector((state) => state.dataQualityReducer.filterExtendedStatsDomains);

  const transformData = useCallback((inputArray) => {
    return inputArray.reduce((acc, item) => {
      const parentText = item.status_name;
      const parentId = item.status_id;
      if (!parentText || parentId === undefined) return acc;

      let parent = acc.find((g) => g.text === parentText && g.id === parentId);
      if (!parent) {
        parent = { text: parentText, id: parentId, items: [] };
        acc.push(parent);
      }
      if (item.id && item.name) {
        parent.items.push({ text: item.name, id: item.id });
      }
      return acc;
    }, []);
  }, []);

  useEffect(() => {
    dispatch(fetchExtendedStatsDomains());
  }, [dispatch]);

  const { treeData, value, onChangeTree, onExpandChange, fields, getTags } =
    useMultiSelectTree({
      rawData: extendedStatsDomains,
      stateValue,
      urlParamKey: "extendedStatsDomains",
      defaultValue,
      transformData,
      setFilterAction: setFilterExtendedStatsDomains,
      expandParentOnInit: true,
      selectionLabel: "extended states",
    });

  return (
    <MultiSelectTree
      id="multiSelectTreeExtendedStats"
      className="form-select-kendo"
      data={treeData}
      value={value}
      onChange={onChangeTree}
      textField="text"
      dataItemKey={fields.dataItemKey}
      checkField={fields.checkField}
      checkIndeterminateField={fields.checkIndeterminateField}
      expandField={fields.expandField}
      subItemsField={fields.subItemsField}
      onExpandChange={onExpandChange}
      adaptive={true}
      size="large"
      tags={getTags()}
    />
  );
};

ExtendedStatsSelector.propTypes = {
  defaultValue: PropTypes.array,
};

export default ExtendedStatsSelector;